/**
 * @flow
 * @relayHash 0d976c020aea0fcceac38f4968562ac1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddEditPOApprovalRuleModalQueryVariables = {||};
export type AddEditPOApprovalRuleModalQueryResponse = {|
  +users: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +firstName: string,
        +lastName: string,
        +email: any,
      |}
    |}>
  |}
|};
export type AddEditPOApprovalRuleModalQuery = {|
  variables: AddEditPOApprovalRuleModalQueryVariables,
  response: AddEditPOApprovalRuleModalQueryResponse,
|};
*/


/*
query AddEditPOApprovalRuleModalQuery {
  users(companyUserRoles: [ADMIN, USER]) {
    edges {
      node {
        id
        firstName
        lastName
        email
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "users",
    "storageKey": "users(companyUserRoles:[\"ADMIN\",\"USER\"])",
    "args": [
      {
        "kind": "Literal",
        "name": "companyUserRoles",
        "value": [
          "ADMIN",
          "USER"
        ]
      }
    ],
    "concreteType": "UserConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddEditPOApprovalRuleModalQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddEditPOApprovalRuleModalQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "AddEditPOApprovalRuleModalQuery",
    "id": null,
    "text": "query AddEditPOApprovalRuleModalQuery {\n  users(companyUserRoles: [ADMIN, USER]) {\n    edges {\n      node {\n        id\n        firstName\n        lastName\n        email\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '166335df64bd909fd5ce7dc827c02a9b';
module.exports = node;
